module.exports = __webpack_public_path__ + "static/img/萌唐唐诗会3.6a8833da.png";